import GroupSummary from "./GroupSummary2";

export default GroupSummary;
